import { QuickOrderEntriesEffects } from './quick-order-entries.effects';
import { QuickOrderSearchEffects } from './quick-order-search.effect';

export const effects: any[] = [
  QuickOrderEntriesEffects,
  QuickOrderSearchEffects,
];
